export const THEME_SETTINGS_COLOR_MODE_OPTIONS = [
  {
    label: "Light",
    value: "LIGHT",
  },
  {
    label: "Dark",
    value: "DARK",
  },
];

export const THEME_SETTINGS_DENSITY_OPTIONS = [
  {
    label: "Tight",
    value: "0.8",
  },
  {
    label: "Regular",
    value: "1",
  },
  {
    label: "Loose",
    value: "1.2",
  },
];

export const THEME_SETTINGS_SIZING_OPTIONS = [
  {
    label: "Small",
    value: "0.8",
  },
  {
    label: "Regular",
    value: "1",
  },
  {
    label: "Big",
    value: "1.2",
  },
];

export const THEME_SETTINGS_BORDER_RADIUS_OPTIONS = [
  { label: "Sharp", value: "0px" },
  { label: "Rounded", value: "6px" },
  { label: "Pill", value: "20px" },
];

export const THEME_SETTINGS_ICON_STYLE_OPTIONS = [
  { label: "Filled", value: "FILLED" },
  { label: "Outlined", value: "OUTLINED" },
];

export const THEME_SETTING_COLOR_PRESETS = {
  LIGHT: ["#0080ff", "#6b35ff", "#d54137", "#f09326", "#02925c"],
  DARK: ["#0080ff", "#5b02ea", "#c12c26", "#e98b11", "#03854e"],
};
